<tt-tag-grid
  [ngModel]="selected()"
  [optionTemplate]="optionTemplate"
  [possibleOptions]="codeValues()"
  [selectedTemplate]="selectedTemplate"
  (ngModelChange)="handleValuesSelected($event)" />

<ng-template #optionTemplate let-option>
  <span class="tt-value-set-picker_text">
    {{ option.value.title }} <span class="tt-value-set-picker_code"> - {{ option.value.code }} </span>
  </span>
</ng-template>

<ng-template #selectedTemplate let-option>
  {{ option.value.title }}
</ng-template>
